import { useMemo } from 'react';
import useThemeContext from './useThemeContext';
export default function useTheme(styleGenerator, props = {}, deps = []) {
    const themeContext = useThemeContext();
    const data = useMemo(() => ({
        ...themeContext,
        styles: (styleGenerator
            ? styleGenerator(themeContext, props)
            : undefined),
    }), [themeContext, styleGenerator, ...deps]);
    return [data];
}
